export default __webpack_public_path__ + "static/media/img-0642-north-macedonia-full-face.14395554.png";